import React from "react";
import { H4 } from "../../../../AbstractElements";
import { FormGroup, Label } from "reactstrap";

export default function EntitiesPermissions({ register, handleAll }) {
  return (
    <div>
      <H4 attrH4={{ className: "mb-3 mt-2" }}>Entidades</H4>
      <FormGroup className="m-t-15 m-checkbox-inline m-0">
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="list_entity"
            type="checkbox"
            {...register("permissions.list_entity", {})}
          />
          <Label for="list_entity">
            {Option}
            <span className="digits"> Ver</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="create_entity"
            type="checkbox"
            {...register("permissions.create_entity", {})}
          />
          <Label for="create_entity">
            {Option}
            <span className="digits"> Crear</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="edit_entity"
            type="checkbox"
            {...register("permissions.edit_entity", {})}
          />
          <Label for="edit_entity">
            {Option}
            <span className="digits"> Modificar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="delete_entity"
            type="checkbox"
            {...register("permissions.delete_entity", {})}
          />
          <Label for="delete_entity">
            {Option}
            <span className="digits"> Eliminar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            onChange={handleAll}
            className="p-0 m-0"
            id="entity"
            type="checkbox"
          />
          <Label for="entity">
            {Option}
            <span className="digits"> Todos</span>
          </Label>
        </div>
      </FormGroup>
    </div>
  );
}
